import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function usePurchases(page = 1) {
  return useQuery({
    queryKey: ['purchases', page],
    queryFn: () => api.purchases.list({ page: String(page) }),
  });
}

export function usePurchase(purchaseId: string) {
  return useQuery({
    queryKey: ['purchases', purchaseId],
    queryFn: () => api.purchases.get(purchaseId),
    enabled: purchaseId.length > 0,
  });
}
